import React from 'react';
import CompetitionModule from 'app/components/competitionModule/CompetitionModule';
import { CompetitionModuleList } from 'app/components/competitionModule/common/CompetitionModuleList';
export default function SecondAndThirdCompetitionModule(_ref) {
  let {
    data
  } = _ref;
  const competitionModules = data.getSecondAndThirdCompetitionModule();
  if (!competitionModules) {
    return null;
  }
  return /*#__PURE__*/React.createElement(CompetitionModuleList, {
    "data-sentry-element": "CompetitionModuleList",
    "data-sentry-component": "SecondAndThirdCompetitionModule",
    "data-sentry-source-file": "SecondAndThirdCompetitionModule.tsx"
  }, competitionModules.map(moduleData => {
    return /*#__PURE__*/React.createElement(CompetitionModule, {
      key: moduleData.slug,
      data: moduleData
    });
  }));
}